import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, useContext, useMeta } from "@nuxtjs/composition-api";

import { useCategory, useLtkHashtagFeed, useMetaService, useTranslate } from "@/composables";
import { withAvatar } from "@/utils/services/LtkItemHeightCalculator";

const __default__ = defineComponent({
  name: "CategoryHash",
  head: {},
  fetchDelay: 0,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const ctx = useContext();
const { t } = useTranslate();
const metaService = useMetaService();
const { description, hashtag, displayName, image } = useCategory(ctx.params.value.category?.toLowerCase() ?? "");
const { onPaging, ltks, fetchState } = useLtkHashtagFeed(hashtag, true);

const imgWidth = 244;
const itemHeightFunction = withAvatar;

useMeta({
  ...metaService.setPageMeta({
    title: t("Shop curated {categoryName} products on LTK", { categoryName: displayName.value ?? "" }),
    customTitle: true,
    description: description.value ?? "",
  }),
  ...metaService.setOGImg(image.value, imgWidth),
});

return { __sfc: true,ctx, t, metaService, description, hashtag, displayName, image, onPaging, ltks, fetchState, imgWidth, itemHeightFunction }
}

})